import { createContext } from "react";

export const BlogsContext = createContext([]);
